<template>
    <div class="pricing4">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8 text-center">
                    <h3 class="mb-3">{{ $t("pages.home.title") }}</h3>
                    <h6 class="subtitle font-weight-normal">
                        {{ $t("pages.home.description") }}
                    </h6>
                </div>
            </div>

            <div class="row mt-4">
                <FormSelector
                    v-for="(form, index) in forms"
                    :key="index"
                    :image="form.image"
                    :title="form.title"
                    :description="form.description"
                    :features="form.features"
                    :active="form.active"
                    :route-to="form.route"
                />
            </div>
        </div>
    </div>
</template>

<script>
import FormSelector from "../../components/FormSelector";
export default {
    components: { FormSelector },
    computed: {
        forms() {
            return [
                {
                    image: "../../images/ppg-capilar.jpg",
                    title: this.$i18n.t("pages.home.cards.ppg-capilar.title"),
                    description: this.$i18n.t(
                        "pages.home.cards.ppg-capilar.description"
                    ),
                    features: this.$i18n.t(
                        "pages.home.cards.ppg-capilar.points"
                    ),
                    active: true,
                    route: "capilar-form"
                }
            ];
        }
    }
};
</script>
